export default function scrollToTop(selector) {
  document.querySelector(selector)?.scrollTo(0, 0);
}
